<script setup lang="ts">
type Props = {
  width?: number | `${string}%`;
  height?: number | `${string}%`;
};

const { width = 400, height = 130 } = defineProps<Props>();
</script>

<template>
  <div
    :style="{
      width: typeof width === 'number' ? `${width}px` : width,
      height: typeof height === 'number' ? `${height}px` : height,
    }"
    class="animate-pulse-enhanced bg-platform-bg-2 rounded-md"
  />
</template>
